


















import Vue from "vue";

export default Vue.extend({
  props: {
    r: {
      type: Number,
      required: true,
    },
    x: {
      type: Number,
      required: true,
    },
    y: {
      type: Number,
      required: true,
    },
    dx: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    rtl: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    cx(): number {
      return this.rtl ? this.x - this.r : this.x + this.r;
    },
  },
});
